const vorhersageMappings = [
  /**
   * regex usage: /^TX_( group1 )="( group2 )"/gi
   *
   * placeholders for regex group1 in jsontree:
   * - use @ as string placeholder
   * - use $ as int placeholder
   * - use [field=$] for array elements with specific field
   *
   * group2 will be applied as parameter with jsonkey
   * */

  // heute nacht
  {
    prefix: 'T_n_',
    jsontree: 'maps.heute-nacht.items.@.data.temperature.value'
  },
  {
    prefix: 'P_n_',
    jsontree: 'maps.heute-nacht.items.@.data.icon.value'
  },
  // morgen vormittag
  {
    prefix: 'T_vm_',
    jsontree: 'maps.morgen-vormittag.items.@.data.temperature.value'
  },
  {
    prefix: 'P_vm_',
    jsontree: 'maps.morgen-vormittag.items.@.data.icon.value'
  },
  {
    prefix: 'Wdir_vm_',
    jsontree: 'maps.morgen-vormittag.items.wind.data.direction.value'
  },
  {
    prefix: 'Wvel_vm_',
    jsontree: 'maps.morgen-vormittag.items.wind.data.velocity.value'
  },
  // morgen nachmittag
  {
    prefix: 'T_nm_',
    jsontree: 'maps.morgen-nachmittag.items.@.data.temperature.value'
  },
  {
    prefix: 'P_nm_',
    jsontree: 'maps.morgen-nachmittag.items.@.data.icon.value'
  },
  {
    prefix: 'Wdir_nm_',
    jsontree: 'maps.morgen-nachmittag.items.wind.data.direction.value'
  },
  {
    prefix: 'Wvel_nm_',
    jsontree: 'maps.morgen-nachmittag.items.wind.data.velocity.value'
  },
  // prognose
  {
    prefix: 'T_Tag',
    jsontree: 'maps.prognose.items.tag$-tag.data.temperature.value'
  },
  {
    prefix: 'P_Tag',
    jsontree: 'maps.prognose.items.tag$-tag.data.icon.value'
  },
  {
    prefix: 'T_Nacht',
    jsontree: 'maps.prognose.items.tag$-nacht.data.temperature.value'
  },
  {
    prefix: 'P_Nacht',
    jsontree: 'maps.prognose.items.tag$-nacht.data.icon.value'
  },
  {
    prefix: 'Wvel_Tag',
    jsontree: 'maps.prognose.items.tag$-wind.data.wind.value'
  },
  {
    prefix: 'NProb_Tag',
    jsontree: 'maps.prognose.items.tag$-regen.data.rain.value'
  },
  {
    prefix: 'Shrs_Tag',
    jsontree: 'maps.prognose.items.tag$-sonne.data.sun.value'
  }
];
const tendenzenMappings = [
  // tendenz
  {
    prefix: 'TX_',
    // jsontree: 'maps.tendenz.items.tx-maxima.data.temperatures.value[name=TX_@].value'
    jsontree: 'maps.tendenz.items.tx-maxima.data.temperatures.value.$.value'
    // jsontree: 'maps.tendenz.items.tx-maxima.data.temperatures.value.[field=$].value'
    // jsontree: 'maps.tendenz.items.tag-@.data.iconIndex.value'
  },
  {
    prefix: 'E_TX_',
    jsontree: 'maps.tendenz.errorRange[name=E_TX_@].value'
  },
  {
    prefix: 'P_Tag',
    jsontree: 'maps.tendenz.items.tag-@.data.iconIndex.value'
  }
];

export {vorhersageMappings, tendenzenMappings};
